import {
    SET_DRIVER_TITLE,
} from "./DriverTitleType";

const reducers = (state = [], action: any) => {
    switch (action.type) {
        case SET_DRIVER_TITLE:
            return {
                ...state,
                driverTitleDropDownList: action.driverTitleList,
            };
        default:
            return state;
    }
};

export { reducers };
